import { render, staticRenderFns } from "./common-email.vue?vue&type=template&id=472d17dc"
import script from "./common-email.vue?vue&type=script&lang=js"
export * from "./common-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports